const state = {
  token: ''
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js